import getPromoItemByCurrency from '../getPromoItemByCurrency';
import { ImagePerLanguage, SettingsPerCurrency } from '../types';

const getPromoImage = (
  settingsPerCurrency: SettingsPerCurrency[],
  imagesPerLanguage: ImagePerLanguage[],
  language: string,
  platform: keyof SettingsPerCurrency,
  currentCurrency: string,
  getImg: (imageLink?: string, imageLinkDark?: string) => string
): string | undefined => {
  const promoImagePerCurrency = getPromoItemByCurrency(
    settingsPerCurrency,
    currentCurrency,
    language,
    platform,
    getImg,
    'images'
  );

  const imagePerLanguage = imagesPerLanguage?.find(
    ({ language: imageLang }) => imageLang === language
  );
  const promoImagePerLanguage =
    getImg(imagePerLanguage?.imageLink, imagePerLanguage?.imageLinkDark) ||
    imagePerLanguage?.imageLink;

  return promoImagePerCurrency || promoImagePerLanguage;
};

export default getPromoImage;
